import {h, Component, Fragment} from 'preact';
import Config from "../config";
import Page from "../../../services/page-data-feed";
import IframeMessages from "../../../services/iframe-messages";
import MobilePage from "../utils/mobile-page.jsx";

import MobileHeader from "../mobile-components/site/mobile-header";
import MobileFooter from "../mobile-components/site/mobile-footer";
import MenuRight from "../mobile-components/site/menu-right";
import MenuLeft, {HorizontalTopMenu} from "../mobile-components/site/menu-left";

import PopupLogin from "../mobile-components/site/popup-login";
import PopupRegister from "../mobile-components/site/popup-register";
import PopupRecovery from "../mobile-components/site/popup-recovery";


IframeMessages.onCartNavigation = () => {MobilePage.toggleTicket();Page.rerender();}
IframeMessages.onSportNavigation = () => {MobilePage.setPage({name: 'home', data: {view: 'menu', sport: '/sport/1'}});Page.rerender();}

export default function FullSite({children, ...props}) {
	return <div class="mobile-page font-roboto">
		{!Config.hideHeader && <MobileHeader />}
		{!Config.hideHeader && <HorizontalTopMenu onClick={null} />}
		
		<div class={"min-h-screen"+(props['class'] ? " "+props['class'] : '')}>{children}</div>
		
		{!Config.hideFooter && <MobileFooter />}

		<MenuLeft />
		<MenuRight />

		<PopupLogin />
		<PopupRegister />
		<PopupRecovery />
	</div>;
}
